import React, { memo } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { NoAvailableMessageIcons } from './NoAvailableMessage.constants';
import NoAvailableMessageContent from './NoAvailableMessageContent';

const NoAvailableMessage = ({
  message = '',
  className = '',
  Icon = NoAvailableMessageIcons.NO_DATA,
}) => (
  <div className={clsx(className, 'flex flex-col flex-1 items-center justify-center p-16')}>
    <div className="max-w-512 text-center">
      <NoAvailableMessageContent Icon={Icon} message={message} />
    </div>
  </div>
);

NoAvailableMessage.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
  Icon: PropTypes.func,
};

export default memo(NoAvailableMessage);
